import axios from 'axios'
import store from '../modules/login/store/login'
import { getToken } from '@/utils/auth'
import { get } from 'lodash-es'
import Vue from 'vue'
import { Message } from 'element-ui'
export function request(config) {
  // 创建axios的实例
  const instance = axios.create({
    baseURL: Vue.prototype.baseUrl,
    timeout: 10000
  })
  // axios.interceptors  全局拦截
  // 请求拦截
  instance.interceptors.request.use(
    config => {
      // 拦截请求
      if (store.state.token) {
        config.headers['Authorization'] = getToken() // 让每个请求携带自定义token 请根据实际情况自行修改
      }
      return config // 若拦截到需要原封不动的返回
    },
    err => {
      console.log(err)
    }
  )
  // 响应拦截
  instance.interceptors.response.use(
    res => {
      const flag = get(res.data, 'flag')
      if (flag) {
        let data = get(res, 'data.data')
        //兼容支付 data为null，返回内容在msg中
        // if (!data && res && res.data.code === 20000) {
        //   data = res.data.msg
        // }
        return data
      } else {
        const message = get(res, 'data.msg')
        let data = ''
        if (res.data.data) {
          data = get(res, 'data.data')
        }
        // const error =
        // new Error(data || "失败");
        const error = res.data || '失败'
        let dataObj = res.data
        Message({
          message: dataObj.data || dataObj.msg || '失败',
          type: 'warning',
          duration: 2000
        })
        throw error
      }
    },
    err => {
      console.log('响应拦截' + err)
    }
  )
  // 3.发送真正的网络请求
  return instance(config)
}
